<template>
  <div class="default-layout">
    <slot />
    <fp-footer />
  </div>
</template>

<style lang="scss" scoped>
.default-layout {
  position: relative;
  color: var(--clr-text-primary);
  background: var(--clr-text-primary);
  font-family: var(--font);
  letter-spacing: .5px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  justify-content: space-between;
  min-height: 100dvh;
}
</style>
